<script lang="ts">
	import { Command as CommandPrimitive } from 'bits-ui'
	import { cn } from 'tailwind-variants'

	export type CommandRootApi = CommandPrimitive.Root

	let {
		api = $bindable(null),
		ref = $bindable(null),
		value = $bindable(''),
		class: className,
		...restProps
	}: CommandPrimitive.RootProps & {
		api?: CommandRootApi | null
	} = $props()
</script>

<CommandPrimitive.Root
	bind:this={api}
	class={cn(
		'bg-popover text-popover-foreground flex size-full flex-col overflow-hidden rounded-xl! p-1',
		className
	)}
	data-slot="command"
	bind:value
	bind:ref
	{...restProps}
/>
